import { PromotersVerificationModule } from '@/modules/promoters/verification';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccessDenied } from '../../../../components/ui/access-denied';
import { useAccessControl } from '../../../../hooks/useAccessControl';

const verificationSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(10),
  search: z.string().optional(),
  type: z.enum(['INDIVIDUAL', 'BUSINESS']).optional(),
});

export const Route = createFileRoute('/dashboard/promoters/verification/')({
  validateSearch: verificationSearchSchema,
  component: PromotersVerificationPage,
});

function PromotersVerificationPage() {
  const { canAccessPromoterProfile } = useAccessControl();

  if (!canAccessPromoterProfile) {
    return <AccessDenied />;
  }

  return <PromotersVerificationModule />;
}
